<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${purchasesOrder.code}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="purchasesOrder" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "purchasesOrder-view-logs",

  components: { LogListTable },

  props: ["purchasesOrder"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
